module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/close.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/close.png
// module id = 530
// module chunks = 367